import React, {forwardRef, useEffect, useImperativeHandle, useState} from "react";
import {
    ARRAY_COLORS,
    ARRAY_COLORS_DRAW,
    ARRAY_COLORS_MAIN,
    ARRAY_DEFAULT_COLORS, ARRAY_DEFAULT_COLORS_1,
    DEFAULT_CANVAS_BACKGROUND
} from "../../Const";
import {generateUUID2, getImagePathSvg} from "../../utils";
import {Alpha, hexToHsva, hexToRgba, hsvaToHexa, validHex} from "@uiw/react-color";
import {HsvaColor} from "@uiw/color-convert/src";
import {t} from "i18next";
import {getSelectedElements} from "../../../@excalidraw/packages/excalidraw/scene";

const ColorChoose = forwardRef((props:{onColorClicked:any,defaultColor:any,from?:any}, ref)=>{
    useImperativeHandle(ref,()=>({
        onSetCurrentHexColor:onSetCurrentHexColor
    }));

    const [currentHexColor,setCurrentHexColor] = useState("#000000");

    function onSetCurrentHexColor(szHexColor){
        setCurrentHexColor(szHexColor);
    }

    useEffect(()=>{
        if (props.defaultColor){
            setCurrentHexColor(props.defaultColor)
        }
    },[props.defaultColor])

    /**
     * 最近颜色
     */
    const getLastestColors = ()=>{
        let arrayColors = [];
        const colors = localStorage.getItem("lastestCanvasColor");
        if (colors != null && colors !== ''){
            arrayColors = JSON.parse(colors);
        }
        return arrayColors;
    }
    //保存最近的颜色
    const setLastestColors = (szNewHexColor:string)=>{
        let arrayColors = getLastestColors();
        //remove 重复的...
        for (let i=arrayColors.length-1;i>=0;i--){
            if (arrayColors[i].toLowerCase() === szNewHexColor.toLowerCase()){
                arrayColors.splice(i,1);
            }
        }
        let maxCount = arrayColors.length;
        if (maxCount > 17){
            maxCount = 17;
        }
        let arrayNewColors = [szNewHexColor];
        for (let i=0;i<maxCount;i++){
            arrayNewColors.push(arrayColors[i]);
        }
        localStorage.setItem("lastestCanvasColor",JSON.stringify(arrayNewColors));
    }

    return (
        <div className='font-size-12'
             style={{
                 margin: '-24px -24px -32px -24px',
                 padding: '18px 15px',
                 backgroundColor: 'var(--dialog-background-color)',
                 width: '248px',
                 borderRadius: '8px',
             }} onMouseUp={(e)=>{
                 e.stopPropagation();
        }} onMouseDown={(e)=>{
            e.stopPropagation();
        }}>
            <span>{t("Default colors")}</span>
            <div style={{display: 'flex', flexWrap: 'wrap', marginTop: '2px'}}>
                {
                    (props.from == 'mindmap'?ARRAY_DEFAULT_COLORS_1:ARRAY_DEFAULT_COLORS).map(item => <div className={'cursor-pointer'} key={generateUUID2()}
                                                          data-color={item} style={{
                        width: '20px',
                        height: '20px',
                        margin: '3px 2px',
                        backgroundColor: item,
                        borderRadius: '10px',
                        border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
                    }} onClick={(e) => {
                        e.stopPropagation();
                        let szHexColor = e.currentTarget.dataset.color;
                        setCurrentHexColor(szHexColor as string);
                        props.onColorClicked(szHexColor);

                        setLastestColors(szHexColor as string);
                    }}>

                        {
                            item == 'transparent' &&
                            <img className={'img-20'} src={getImagePathSvg('color_transparent')}/>
                        }

                    </div>)
                }
            </div>
            <div className={'line'} style={{margin: '10px 0'}}></div>

            <span>{t("palette")}</span>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                {
                    ARRAY_COLORS.map(item => <div key={generateUUID2()} data-color={item} style={{
                        width: '20px',
                        height: '20px',
                        margin: '3px 2px',
                        backgroundColor: item,
                        borderRadius: '2px',
                        cursor: 'pointer',
                        border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
                    }} onClick={(e) => {
                        let szHex = e.currentTarget.dataset.color;
                        props.onColorClicked(szHex as string);
                        setLastestColors(szHex as string);
                    }}></div>)
                }
            </div>
            {/*{ h: 0, s: 0, v: 0, a: 1 }*/}
            <div style={{height: '12px'}}></div>
            <div className='flex-row-vertical-center' style={{width: '100%'}}>
                <Alpha
                    style={{flexGrow: '1', marginLeft: '0px'}}
                    hsva={
                        hexToHsva(currentHexColor || DEFAULT_CANVAS_BACKGROUND)
                    }
                    onChange={(newShade) => {
                        let szHexColor = hsvaToHexa(newShade as HsvaColor);
                        setCurrentHexColor(szHexColor);
                        props.onColorClicked(szHexColor, false);
                        console.log(Math.round(hexToRgba(szHexColor || DEFAULT_CANVAS_BACKGROUND).a * 100) + '%')
                    }}
                />
            </div>

            <div style={{marginTop: '12px', width: '100%'}}>
                <span>HEX</span>
                <input className={'input-border'} readOnly={false} style={{
                    flexGrow: '1',
                    borderRadius: '4px',
                    outline: 'none',
                    margin: '0 16px',
                    height: '24px',
                    textAlign: 'center',
                    width: '130px',
                }}
                       value={
                           currentHexColor
                       }

                       onChange={(e) => {
                           const szHexColor = e.currentTarget.value;

                           if (validHex(szHexColor)) {
                               setCurrentHexColor(szHexColor);
                               props.onColorClicked(szHexColor);
                           } else {
                               let szOriHex = 'TRANSPARENT';
                           }
                           // setCanvasTempBackgroundColor(szHexColor);
                       }}
                />
                <span>{
                    Math.round(hexToRgba(currentHexColor || DEFAULT_CANVAS_BACKGROUND).a * 100) + '%'
                }</span>
            </div>
            <div className='line' style={{margin: '12px 0'}}></div>

            <span className='text-color-a'>{t("lastestUse")}</span>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                {
                    getLastestColors().map(item => <div key={generateUUID2()} data-color={item} style={{
                        width: '20px',
                        height: '20px',
                        margin: '3px 2px',
                        backgroundColor: item,
                        borderRadius: '2px',
                        cursor: 'pointer',
                        border: ("#FFFFFF" === item) ? '1px solid #E6E3EE' : '0px'
                    }} onClick={(e) => {
                        let szHexColor = e.currentTarget.dataset.color;
                        setCurrentHexColor(szHexColor as string);
                        props.onColorClicked(szHexColor);

                        setLastestColors(szHexColor as string);
                    }}></div>)
                }
            </div>
        </div>
    )
})

export default ColorChoose;